import { formatDate, Formats } from '@/shared/utils/DateFormater';
import { getCurrentInstance, inject, type App } from 'vue';
import { i18n } from '@/app/plugins/i18n';
import type { Locale } from '@/shared/constants/locales';


const dateFormatterKey = Symbol('dateFormatter');

type DateFormatter = {
    (date: Date | string, format: keyof typeof Formats): string;
    Formats: typeof Formats;
};

const dateFormatter: DateFormatter = Object.assign(
    (date: Date | string, format: keyof typeof Formats) => {
        if (date instanceof Date) {
            date = date.toISOString();
        }
        const locale = i18n.global.locale.value as Locale;
        return formatDate(date, Formats[format], locale);
    },
    {
        Formats,
    },
);

export const dateFormatterPlugin = {
    install(app: App) {
        app.config.globalProperties.$dateFormatter = dateFormatter;
        app.provide(dateFormatterKey, dateFormatter);
    },
};

export function useDateFormatter(): DateFormatter {
    const injected = inject<DateFormatter>(dateFormatterKey);
    if (injected) {
        return injected;
    }

    const instance = getCurrentInstance();
    if (!instance) {
        throw new Error('useDateFormatter must be called inside setup');
    }

    return instance.appContext.config.globalProperties.$dateFormatter;
}

declare module 'vue' {
    export interface ComponentCustomProperties {
        $dateFormatter: DateFormatter;
    }
}
